var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('accuterm-gui',{key:"accuterm-gui-component",attrs:{"profile":_vm.profile,"request":_vm.guiRequest},on:{"passResponse":_vm.handleResponse,"toTerminal":_vm.backToTerminal}})}
var staticRenderFns = []

export { render, staticRenderFns }